module.exports = __webpack_public_path__ + "static/media/gi.064b5694.jpg";